import { render, staticRenderFns } from "./FbProfile.vue?vue&type=template&id=51f670c7"
import script from "./FbProfile.vue?vue&type=script&lang=js"
export * from "./FbProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports